/* eslint-disable no-underscore-dangle */
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Selector, SelectorOption } from '@fashionnovateam/nova-ui-toolkit';
import { HelpCenterBreadcrumbs } from '../Navigation/HelpCenterBreadcrumbs';
import { BaseHelpCenterProps } from '../types';

export function SectionView({ helpCenterData }: BaseHelpCenterProps) {
  const { userId, sectionTitle } = useParams<{
    userId: string;
    sectionTitle: string;
  }>();
  const history = useHistory();

  const currentSection = helpCenterData?.sections.find(
    (s) => s.title.toLowerCase() === sectionTitle?.toLowerCase(),
  );

  if (!currentSection) return null;

  const handleArticleSelect = (values: string[]) => {
    const selectedValue = values[values.length - 1];
    if (selectedValue) {
      history.push(
        `/users/${userId}/help-center/${sectionTitle}/${selectedValue}`,
      );
    }
  };

  return (
    <div className="max-w-[800px] px-4 sm:px-2 md:px-0">
      <HelpCenterBreadcrumbs helpCenterData={helpCenterData} />
      <div className="flex flex-col md:flex-row justify-between items-start">
        <div className="flex-1">
          <h1 className="text-2xl md:text-4xl font-medium mb-1 md:mb-2">
            {currentSection.title}
          </h1>
          <p className="text-base md:text-lg nu-text-base-disabled mb-4 md:mb-8">
            {currentSection.description}
          </p>
        </div>
        <img
          src={currentSection.icon?.viewUrl || ''}
          alt={currentSection.title}
          className="w-8 h-8 md:w-12 md:h-12 mt-6 md:mt-12"
        />
      </div>
      <p className="mt-6 md:mt-12 mb-6 md:mb-12 border-b-[0.25px] nu-text-neutral-100" />

      <p className="text-xs md:text-xsm font-medium mb-2 md:mb-3">Articles</p>
      <Selector
        onChange={handleArticleSelect}
        className="grid grid-cols-1 md:grid-cols-2 gap-2 [&>label]:!m-0"
      >
        {currentSection.articles.map((article) => (
          <SelectorOption
            key={article._id}
            value={article._id}
            label={article.title}
            name={`article-${article._id}`}
            noMargin
          >
            <div className="flex items-center p-3 md:p-6 w-full">
              <div>
                <h2 className="text-sm md:text-md font-medium">
                  {article.title}
                </h2>
                <p className="text-xs md:text-sm nu-text-base-disabled">
                  {article.description}
                </p>
              </div>
            </div>
          </SelectorOption>
        ))}
      </Selector>
    </div>
  );
}
